<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { useRoute } from 'vue-router'

import { usePermissions } from '@/composables/usePermissions.ts'
import { RouteNames } from '@/router/routes.ts'
import { useDepartmentsStore } from '@/stores/departments/departments.ts'

import Row from '@uikit/layout/Row.vue'
import Logo from '@/components/Logo.vue'
import FlexChild from '../uikit/layout/FlexChild.vue'
import Account from './account/Account.vue'
import NavLink from './NavLink.vue'
import UndoRedoControls from './undoredo/UndoRedoControls.vue'

import CalendarIcon from '~mingcute/business/calendar_month_line.svg'
import CouponIcon from '~mingcute/business/coupon_line.svg'
import BookIcon from '~mingcute/education/book_6_line.svg'

const route = useRoute()
const deptStore = useDepartmentsStore()
const permissionComposable = usePermissions()
</script>

<template>
  <Row as="header" alignment="center" :gap="6">
    <div class="logo">
      <RouterLink :to="{ name: RouteNames.HOME }" :title="$t('header.homepage')">
        <Logo />
      </RouterLink>
    </div>

    <Row v-if="deptStore.isCurrentDepartmentSelected" as="nav" alignment="center" :gap="6">
      <NavLink :to="RouteNames.DEPARTMENT_SCHEDULE">
        <CalendarIcon />
        <span>{{ $t('header.nav.schedule') }}</span>
      </NavLink>
      <NavLink
        v-if="permissionComposable.canAccessManage(deptStore.current.id)"
        :to="RouteNames.DEPARTMENT_MANAGEMENT_COURSES"
      >
        <BookIcon />
        <span>{{ $t('header.nav.course-management') }}</span>
      </NavLink>
    </Row>
    <NavLink :to="RouteNames.ROOM_RESERVATION">
      <CouponIcon />
      <span>{{ $t('header.nav.reservation') }}</span>
    </NavLink>
    <FlexChild placement-end>
      <Row alignment="center" :gap="6">
        <!-- TODO: Ribbon button -->
        <UndoRedoControls v-if="!route.meta.undoredoEnabled" />
        <Account />
      </Row>
    </FlexChild>
  </Row>
</template>

<style scoped>
header {
  height: 3rem;
  margin: 0.75rem;
}

.logo {
  height: 100%;
}
</style>
